// src/context/ModalContext.js
import { createContext, useState } from "react";

import AnalysisModal from "../modals/AnalysisModal";
import CardCreateModal from "../modals/CardCreateModal";
import CardModal from "../modals/topic/CardModal";
import CurlConsoleModal from "../modals/CurlConsoleModal";
import DashboardUpdateModal from "../modals/DashboardUpdateModal";
import ManageTopics from "../modals/topic/ManageTopics";

export const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [activeModal, setActiveModal] = useState({
    type: null, // 'card', 'console', 'automation', etc.
    data: null, // Data associated with the modal, including functions
  });

  const openModal = (type, data = null) => {
    setActiveModal({ type, data });
  };

  const closeModal = () => {
    setActiveModal({ type: null, data: null });
  };

  return (
    <ModalContext.Provider value={{ activeModal, openModal, closeModal }}>
      {children}
      {activeModal.type === "console" && (
        <CurlConsoleModal token={activeModal.data.token} onClose={closeModal} />
      )}

      {activeModal.type === "manage-topics" && (
        <ManageTopics token={activeModal.data.token} onClose={closeModal} />
      )}

      {activeModal.type === "analysis" && (
        <AnalysisModal token={activeModal.data.token} onClose={closeModal} />
      )}

      {activeModal.type === "card" && (
        <CardModal
          token={activeModal.data.token}
          card={activeModal.data.card}
          topic={activeModal.data.topic}
          onClose={closeModal}
          onTrashCanIconPress={activeModal.data.onTrashCanIconPress}
        />
      )}
      {activeModal.type === "card-create" && (
        <CardCreateModal token={activeModal.data.token} onClose={closeModal} />
      )}

      {activeModal.type === "dashboard-update" && (
        <DashboardUpdateModal
          token={activeModal.data.token}
          name={activeModal.data.name}
          onRename={activeModal.data.onRename}
          onClose={closeModal}
        />
      )}
    </ModalContext.Provider>
  );
};
